import styled from "@emotion/styled";
import { rem } from "polished";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
`;

export const Dialog = styled.div`
  background: #ffffff;
  border-radius: ${rem(4)};
  box-shadow: 0 ${rem(4)} ${rem(20)} rgba(0, 0, 0, 0.25);
  width: ${rem(420)};
  max-width: calc(100vw - ${rem(32)});
  padding: ${rem(24)};
`;

export const Title = styled.h2`
  margin: 0 0 ${rem(8)} 0;
  font-size: ${rem(18)};
  font-weight: 600;
`;

export const Description = styled.p`
  margin: 0 0 ${rem(16)} 0;
  font-size: ${rem(13)};
  color: #555555;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  margin-bottom: ${rem(16)};
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  font-size: ${rem(14)};
  cursor: pointer;
`;

export const DateFieldLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  font-size: ${rem(14)};
  margin-bottom: ${rem(16)};
`;

export const DateInput = styled.input`
  padding: ${rem(6)} ${rem(8)};
  font-size: ${rem(14)};
  border: 1px solid #cccccc;
  border-radius: ${rem(4)};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${rem(8)};
`;
